<template>
<div>
  <slot></slot>
</div>
</template>

<style>
  @import "~flickity/dist/flickity.min.css";

  /* Flickity */

.flickity-prev-next-button {
  position: absolute;
  top: 50%;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: #fff;
  background: hsla(0, 0%, 100%, .75);
  background: none;
  cursor: pointer;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.flickity-prev-next-button.next {
  right: 2%;
  right: calc(2% - 5px);
}

.flickity-prev-next-button.previous {
  left: 2%;
  left: calc(2% - 5px);
}

.flickity-prev-next-button,
.flickity-prev-next-button:hover {
  background: none;
}

.flickity-prev-next-button svg {
  left: 20%;
  top: 0%;
  width: 80%;
  height: 100%;
}

.flickity-prev-next-button .arrow {
  stroke-width: 0px;
  opacity: 0.5;
  stroke: #fff;
}

.flickity-prev-next-button:focus {
  outline: none;
  box-shadow: none;
}

.flickity-page-dots {
  bottom: -30px;
}

.flickity-page-dots .dot {
    width: 8px;
    height: 8px;
    margin: 0 6px;
}


@media screen and (max-width: 960px) {
  .flickity-page-dots .dot {
      width: 6px;
      height: 6px;
      margin: 0 4px;
  }
  .flickity-page-dots {
    bottom: -20px;
  }
}
</style>

<script>
import Flickity from 'flickity'

export default {
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  mounted () {
    // this.flickity = new Flickity(this.$el, this.options)
  },

  beforeDestroy () {
    this.flickity.destroy()
    this.flickity = null
  },

  methods: {
    initFlickity () {
      console.log('initFlickity!')
      this.flickity = new Flickity(this.$el, this.options)
    },
    next (isWrapped, isInstant) {
      this.flickity.next(isWrapped, isInstant)
    },
    previous (isWrapped, isInstant) {
      this.flickity.previous(isWrapped, isInstant)
    },
    select (index, isWrapped, isInstant) {
      this.flickity.select(index, isWrapped, isInstant)
    },
    selectCell (value, isWrapped, isInstant) {
      this.flickity.selectCell(value, isWrapped, isInstant)
    },
    resize () {
      this.flickity.resize()
    },
    reposition () {
      this.flickity.reposition()
    },
    prepend (elements) {
      this.flickity.prepend(elements)
    },
    append (elements) {
      this.flickity.append(elements)
    },
    insert (elements, index) {
      this.flickity.insert(elements, index)
    },
    remove (elements) {
      this.flickity.remove(elements)
    },
    playPlayer () {
      this.flickity.playPlayer()
    },
    stopPlayer () {
      this.flickity.stopPlayer()
    },
    pausePlayer () {
      this.flickity.pausePlayer()
    },
    unpausePlayer () {
      this.flickity.unpausePlayer()
    },
    destroy () {
      this.flickity.destroy()
    },
    reloadCells () {
      this.flickity.reloadCells()
    },
    getCellElements () {
      this.flickity.getCellElements()
    },
    data () {
      return Flickity.data(this.$el)
    },
    on (eventName, listener) {
      this.flickity.on(eventName, listener)
    },
    off (eventName, listener) {
      this.flickity.off(eventName, listener)
    },
    once (eventName, listener) {
      this.flickity.once(eventName, listener)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Flickity.vue?2c4bc54a